module.exports = __webpack_public_path__ + "static/media/G2.62ceb492.png";